import { buildKwkCtaLink } from '@/storyblok/PageContent';
import type { GlobalOrderformSettingsStoryblok } from '@/types/component-types-sb';
import { useEffect } from 'react';

export function useKwkThankYouCta({
  thankYouPageUid,
  currentPageUid,
  isKwKOrder,
  kwkCode,
  orderSettings,
  kwkThankYouCta,
  setKwkThankYouCta,
}: {
  thankYouPageUid: string | undefined;
  currentPageUid: string;
  isKwKOrder: boolean | undefined;
  kwkCode: string | undefined;
  orderSettings: GlobalOrderformSettingsStoryblok | null | undefined;
  kwkThankYouCta: { link: string; text: string } | null;
  setKwkThankYouCta: (cta: { link: string; text: string }) => void;
}): void {
  useEffect(() => {
    if (
      thankYouPageUid !== currentPageUid ||
      !isKwKOrder ||
      !orderSettings?.kwk_landing_page ||
      !orderSettings?.kwk_cta_button_thank_you
    ) {
      return;
    }
    if (kwkThankYouCta) return;

    const link = buildKwkCtaLink(orderSettings.kwk_landing_page, kwkCode);
    setKwkThankYouCta({ link, text: orderSettings.kwk_cta_button_thank_you });
  }, [thankYouPageUid, currentPageUid, isKwKOrder, kwkCode, orderSettings, kwkThankYouCta, setKwkThankYouCta]);
}
